import { enUS, ja } from 'date-fns/locale';

export const DateLocales = {
  en: enUS,
  ja: ja,
} as const;

export const DateRangeStartYear = 2019;

export const ISO_DATE_FORMAT = 'yyyy-MM-dd';
